import styles from './index.module.css';

export function getServerSideProps(){
	return { redirect: { destination: '/discover', basePath: false, permanent: false } };
}

export default function EventRoot(){ return null; }

/**
 * Basic footer for the event pages. Links point to the main INTIX site, so they are plain anchors.
 */
export function Footer(){
	return (
		<footer className={styles.footer} role="contentinfo">
			<nav className={styles.links} aria-label="Footer">
				<a href="/legal/terms">Terms of Use</a>
				<a href="/legal/privacy">Privacy Policy</a>
				<a href="https://help.intix.com" target="_blank" rel="noopener noreferrer">Help</a>
				<a href="/about/contact">Contact Us</a>
			</nav>
			<p className={styles.copyright} suppressHydrationWarning>© {new Date().getFullYear()} INTIX</p>
		</footer>
	);
}
